export default __webpack_public_path__ + "static/media/Synth.52ad33c0.png";